/**
 * A single slot for the app-level reaction to a Cloudflare challenge on an API call.
 *
 * The transport detects the challenge, but only the app can ask the user to reload, so each web
 * app registers one handler (`CloudflareChallengeBanner`) and `handleCloudflareChallenge`
 * notifies it. Free of `window` and React, like `unauthorized.ts`.
 */

export type CloudflareChallengeInfo = {
  url: string;
};

type CloudflareChallengeHandler = (info: CloudflareChallengeInfo) => void;

let handler: CloudflareChallengeHandler | null = null;

export function setCloudflareChallengeHandler(next: CloudflareChallengeHandler | null): void {
  handler = next;
}

/**
 * Never throws: a failing handler must not corrupt the axios rejection chain the original caller
 * is still waiting on.
 */
export function notifyCloudflareChallenge(info: CloudflareChallengeInfo): void {
  if (!handler) return;

  try {
    handler(info);
  } catch {
    // See above.
  }
}
